// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;

    height: 80px;
    background: var(--bg-glass);

    box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.5),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    /* No will-change — header never transforms; it is always fixed.
       will-change + backdrop-filter forces constant GPU blur layer recomposition */
    animation: header-slide-down 1s cubic-bezier(0.22, 1, 0.36, 1) backwards;
}

@keyframes header-slide-down {
    0% {
        transform: translateY(-100%);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

.logo {
    display: flex;
    align-items: center;
    gap: 12px;
}

.logoimage {
    height: 26px;
}

/* ── button group (pill container) ── */

.headerbuttonsection {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background:
        radial-gradient(120% 100% at 50% 0%, rgba(255, 255, 255, 0.15) 0%, transparent 60%),
        var(--bg-header-section);
    padding: 5px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    gap: 3px;
    box-shadow:
        inset 0 1.5px 1px rgba(255, 255, 255, 0.4),
        inset 0 4px 10px rgba(0, 0, 0, 0.5),
        0 4px 12px rgba(0, 0, 0, 0.1);
}

.header .primarybutton {
    padding: 15px 28px;
    font-size: 14px;
    font-weight: 500;
}

/* ── individual nav buttons ── */

.headerbutton {
    position: relative;
    z-index: 1;
    background: transparent;
    border: none;
    padding: 10px 22px;
    border-radius: 999px;
    color: var(--text-nav);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 12px;
    font-family: inherit;
    /* Only transition non-paint properties */
    transition: color 0.3s ease;
}

.headerbutton:hover {
    color: var(--text-nav-hover);
}

.headerbutton.active {
    color: #ffffff;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* ── sliding pill active indicator ── */

.header-active-indicator {
    position: absolute;
    top: 5px;
    bottom: 5px;
    left: 0;
    z-index: 0;
    background: var(--bg-header-active);
    box-shadow: var(--shadow-header-active);
    border-radius: 999px;
    pointer-events: none;
    will-change: transform, width;
    backface-visibility: hidden;
    /* transform + width are compositor-only — no paint/layout triggered */
    transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),
                width 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

/* ── responsive ── */

@media (max-width: 1024px) {
    .headerbutton {
        padding: 8px 16px;
        font-size: 13px;
    }

    .header .primarybutton {
        padding: 12px 22px;
        font-size: 13px;
    }
}

@media (max-width: 768px) {
    .header {
        height: auto;
        padding: 10px 16px;
    }

    .headerbuttonsection {
        display: none;
    }

    .header .primarybutton {
        padding: 10px 20px;
        font-size: 12px;
    }

    .logoimage {
        height: 22px;
    }

    .subheading {
        font-size: 15px;
    }
}

@media (max-width: 480px) {
    .header {
        padding: 8px 12px;
    }

    .header .primarybutton {
        padding: 8px 16px;
        font-size: 11px;
    }

    .logoimage {
        height: 18px;
    }

    .subheading {
        font-size: 13px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/header/header.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;;IAEf,YAAY;IACZ,2BAA2B;;IAE3B;;+CAE2C;IAC3C,2BAA2B;IAC3B,mCAAmC;IACnC;mFAC+E;IAC/E,wEAAwE;AAC5E;;AAEA;IACI;QACI,4BAA4B;QAC5B,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA,wCAAwC;;AAExC;IACI,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B;;gCAE4B;IAC5B,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR;;;qCAGiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA,iCAAiC;;AAEjC;IACI,kBAAkB;IAClB,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,oBAAoB;IACpB,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,wCAAwC;;AAExC;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,OAAO;IACP,UAAU;IACV,mCAAmC;IACnC,uCAAuC;IACvC,oBAAoB;IACpB,oBAAoB;IACpB,6BAA6B;IAC7B,2BAA2B;IAC3B,sEAAsE;IACtE;0DACsD;AAC1D;;AAEA,qBAAqB;;AAErB;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".header {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 100;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 24px;\n\n    height: 80px;\n    background: var(--bg-glass);\n\n    box-shadow:\n        0 8px 32px rgba(0, 0, 0, 0.5),\n        inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    /* No will-change — header never transforms; it is always fixed.\n       will-change + backdrop-filter forces constant GPU blur layer recomposition */\n    animation: header-slide-down 1s cubic-bezier(0.22, 1, 0.36, 1) backwards;\n}\n\n@keyframes header-slide-down {\n    0% {\n        transform: translateY(-100%);\n        opacity: 0;\n    }\n\n    100% {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.logo {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.logoimage {\n    height: 26px;\n}\n\n/* ── button group (pill container) ── */\n\n.headerbuttonsection {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    background:\n        radial-gradient(120% 100% at 50% 0%, rgba(255, 255, 255, 0.15) 0%, transparent 60%),\n        var(--bg-header-section);\n    padding: 5px;\n    border-radius: 999px;\n    display: flex;\n    align-items: center;\n    gap: 3px;\n    box-shadow:\n        inset 0 1.5px 1px rgba(255, 255, 255, 0.4),\n        inset 0 4px 10px rgba(0, 0, 0, 0.5),\n        0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.header .primarybutton {\n    padding: 15px 28px;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n/* ── individual nav buttons ── */\n\n.headerbutton {\n    position: relative;\n    z-index: 1;\n    background: transparent;\n    border: none;\n    padding: 10px 22px;\n    border-radius: 999px;\n    color: var(--text-nav);\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-family: inherit;\n    /* Only transition non-paint properties */\n    transition: color 0.3s ease;\n}\n\n.headerbutton:hover {\n    color: var(--text-nav-hover);\n}\n\n.headerbutton.active {\n    color: #ffffff;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* ── sliding pill active indicator ── */\n\n.header-active-indicator {\n    position: absolute;\n    top: 5px;\n    bottom: 5px;\n    left: 0;\n    z-index: 0;\n    background: var(--bg-header-active);\n    box-shadow: var(--shadow-header-active);\n    border-radius: 999px;\n    pointer-events: none;\n    will-change: transform, width;\n    backface-visibility: hidden;\n    /* transform + width are compositor-only — no paint/layout triggered */\n    transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),\n                width 0.35s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n/* ── responsive ── */\n\n@media (max-width: 1024px) {\n    .headerbutton {\n        padding: 8px 16px;\n        font-size: 13px;\n    }\n\n    .header .primarybutton {\n        padding: 12px 22px;\n        font-size: 13px;\n    }\n}\n\n@media (max-width: 768px) {\n    .header {\n        height: auto;\n        padding: 10px 16px;\n    }\n\n    .headerbuttonsection {\n        display: none;\n    }\n\n    .header .primarybutton {\n        padding: 10px 20px;\n        font-size: 12px;\n    }\n\n    .logoimage {\n        height: 22px;\n    }\n\n    .subheading {\n        font-size: 15px;\n    }\n}\n\n@media (max-width: 480px) {\n    .header {\n        padding: 8px 12px;\n    }\n\n    .header .primarybutton {\n        padding: 8px 16px;\n        font-size: 11px;\n    }\n\n    .logoimage {\n        height: 18px;\n    }\n\n    .subheading {\n        font-size: 13px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
